import { AxiosResponse } from "axios";
import axiosClient from "../../common/axios/axiosConfig";
import { IQueueData } from "../../common/interfaces/IQueueData";

export const getWhiteLabelInfo = async (
  telemedicineToken: string,
  queueId: string
): Promise<void | AxiosResponse<IQueueData>> => {
  if (!queueId) queueId = "";
  const response = await axiosClient.get<IQueueData>(`clinic/pa/${queueId}`, {
    headers: {
      Authorization: `Bearer ${telemedicineToken}`,
    },
  });


  return response;
};
